export const INIT_KIT = "INIT_KIT";
export const FOUND_KIT = "FOUND_KIT";
export const NOT_FOUND_KIT = "NOT_FOUND_KIT";
export const ATTACHING_KIT = "ATTACHING_KIT";
export const ATTACH_SUCCESS = "ATTACH_SUCCESS";
export const ATTACH_ERROR = "ATTACH_ERROR";
export const RESET_ATTACHMENT = "RESET_ATTACHMENT";

export function resetAttachment() {
  return {
    type: RESET_ATTACHMENT,
  };
}

export function getKit(kitNumber) {
  return {
    type: INIT_KIT,
    payload: { kitNumber },
    meta: {
      endpoint: "/installer/kit?kit_number=" + kitNumber,
      success: getKitSuccess,
      error: getKitError,
    },
  };
}

function getKitSuccess(response) {
  if (response.status === "NOT FOUND") {
    return {
      type: NOT_FOUND_KIT,
    };
  } else {
    return {
      type: FOUND_KIT,
      payload: response.data,
    };
  }
}

function getKitError(response) {}

export function attachKit(kitNumber, customerID, serialNumber) {
  return {
    type: "ATTACHING_KIT",
    meta: {
      method: "POST",
      endpoint: "/installer/register",
      body: {
        kitId: kitNumber,
        customerId: customerID,
        serialNum: serialNumber,
      },
      success: attachKitSuccess,
      error: attachKitError,
    },
  };
}

export function attachKitByComponents(
  serializedDesign,
  customerId,
  serialNumber
) {
  return {
    type: "ATTACHING_KIT",
    meta: {
      method: "POST",
      endpoint: "/installer/register_components",
      body: {
        design: serializedDesign,
        customerId: customerId,
        serialNum: serialNumber,
      },
      success: attachKitSuccess,
      error: attachKitError,
    },
  };
}

function attachKitSuccess(response) {
  if (response.info === undefined) {
    return {
      type: "ATTACH_SUCCESS",
    };
  } else {
    return {
      type: "ATTACH_ERROR",
    };
  }
}

function attachKitError(error) {
  return {
    type: "ATTACH_ERROR",
  };
}

export function resetKit() {
  return {
    type: "RESET_KIT",
  };
}



// WEBPACK FOOTER //
// ./src/redux/actions/kit.js